import { useNavigate } from 'react-router-dom';
import { useI18n } from '@/i18n';
import { Button } from '@/components/ui/button';
import { FaCircleArrowLeft } from "react-icons/fa6";

export function RefundPolicy() {
  const { currentLang } = useI18n();
  const navigate = useNavigate();

  return (
    <div className="min-h-[100dvh] bg-gray-50 font-sans pb-32 lg:pb-10">
      <header className="sticky top-0 z-50 w-full bg-white/80 backdrop-blur-xl border-b border-gray-100/50 shadow-[0_4px_20px_rgba(0,0,0,0.03)] transition-all">
        <div className="max-w-2xl mx-auto px-4 py-4 flex items-center justify-between">
          <Button
            variant="ghost"
            size="icon"
            className="rounded-xl hover:bg-gray-50 text-black transition-all active:scale-95"
            onClick={() => navigate(-1)}
          >
            <FaCircleArrowLeft className="h-6 w-6" />
          </Button>
          <h1 className="text-lg font-black tracking-tight text-center flex-1">
            {currentLang === 'bn' ? 'রিফান্ড পলিসি' : 'Refund Policy'}
          </h1>
          <div className="w-10" /> {/* Spacer */}
        </div>
      </header>

      <div className="container mx-auto px-4 max-w-lg mt-6">
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 space-y-4">
          <p className="text-sm text-gray-600 leading-relaxed">
            {currentLang === 'bn' 
              ? 'Chocolate Vibes সবসময় আপনাকে সেরা মানের পণ্য প্রদানে প্রতিশ্রুতিবদ্ধ। তবে কোনো কারণে যদি আপনি আমাদের পণ্য বা সেবায় সন্তুষ্ট না হন, তবে আমাদের একটি সহজ ও স্বচ্ছ রিফান্ড পলিসি রয়েছে।' 
              : 'Chocolate Vibes is committed to providing you with the best quality products. However, if for any reason you are not satisfied, we have a simple and transparent refund policy.'}
          </p>
          
          <h3 className="font-bold text-black border-b border-gray-100 pb-2 mt-6">
            {currentLang === 'bn' ? 'শর্তসমূহ' : 'Conditions'}
          </h3>
          <ul className="list-disc list-inside text-sm text-gray-600 space-y-2 mt-2">
            <li>
              {currentLang === 'bn' ? 'পণ্যটি অব্যবহৃত এবং আসল প্যাকেজিংয়ে থাকতে হবে।' : 'Product must be unused and in original packaging.'}
            </li>
            <li>
              {currentLang === 'bn' ? 'ডেলিভারি পাওয়ার ২৪ ঘণ্টার মধ্যে অভিযোগ করতে হবে।' : 'Complaints must be made within 24 hours of delivery.'}
            </li>
            <li>
              {currentLang === 'bn' ? 'পণ্য ক্ষতিগ্রস্ত হলে প্রমাণস্বরূপ ছবি প্রদান করতে হবে।' : 'Photographic evidence is required for damaged goods.'}
            </li>
          </ul>

          <h3 className="font-bold text-black border-b border-gray-100 pb-2 mt-6">
            {currentLang === 'bn' ? 'রিফান্ড পদ্ধতি' : 'Refund Process'}
          </h3>
          <p className="text-sm text-gray-600 leading-relaxed">
            {currentLang === 'bn' 
              ? 'আপনার অভিযোগ যাচাইয়ের পর, ৭-১০ কর্মদিবসের মধ্যে আপনার বিকাশ, নগদ বা ব্যাংক একাউন্টে রিফান্ড পাঠিয়ে দেওয়া হবে।' 
              : 'Once your claim is verified, the refund will be processed to your bKash, Nagad, or Bank account within 7-10 working days.'}
          </p>
        </div>
      </div>
    </div>
  );
}
